<template>
  <div class="header" :class="{'margenTop' : btnurl}">
      <div class="row m-0">
          <div :class="columnas1">
            <h1 :class="{'interno' : !btnurl}" v-html="msg"></h1>
            <div class="idea" v-html="idea"></div>
            <button class="btn btn-primary" @click="$router.push(btnurl)" v-if="btnurl">{{ btntitle }} <img src="@/assets/images/flechalinkhome.svg" class="flechalinks" /></button>
          </div>
          <div :class="columnas2" v-if="idea">
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String,
    idea: String,
    btnurl: String,
    btntitle: String,
  },
  computed: {
      columnas1: function(){
          if(!this.btnurl && this.idea){
              return 'col-xl-6';
          } else {
              if(!this.idea){
                  return 'col-xl-12';
              } else {
                  return 'col-xl-5';
              }
          }
      },
      columnas2: function(){
          if(!this.btnurl){
              return 'col-xl-6';
          } else {
              return 'col-xl-7';
          }
      },
  },
  mounted: function(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flechalinks {
    height: 15px;
    margin-left: 10px;
}
.btn-primary {
    background-color: #08028A !important;
    border-radius: 0;
    border: 4px solid #00C4FF;
    padding: 6px 30px;
}
.btn-primary:hover {
    background-color: #00C4FF !important;
}
.btn-primary span {
    color: #00C4FF;
    font-size: 30px;
    font-weight: 600;
    line-height: 20px;
    display: block;
    float: right;
    margin-top: 3px;
    margin-left: 12px;
}
.btn-primary:hover span {
    color: #08028A;
}
.imgPrincipal {
    position: absolute;
    top:0 ;
    left:0;
    z-index: -1;
    width: 100%;
}
.header {
    color: #FFF;
    position: absolute;
    z-index: 1000;
    top: 220px;
}
.margenTop {
    top: 180px !important;
}
h1 {
  font-weight: 200;
  font-size: 50px;
}
h1.interno {
  font-weight: 600;
  font-size: 42px;
}
.idea {
    margin: 20px 0 30px 0;
    font-size: 20px;
    line-height: 34px;
    line-height: 28px;
}
.col-xl-5 {
    margin-top: 30px;
}
.col-xl-5 .idea {
    margin: 20px 0 30px 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
}
.col-xl-6 {
    margin-top: 60px;
}
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px)  {
    .col-xl-5 {
        margin-top: 30px;
    }
    h1 {
        margin-top: 80px;
    }
    .col-xl-6 {
        margin-top: 0px;
    }
    .avbar-toggler {
        display: block !important;
    }
}
@media only screen and (max-width: 767px){
    .col-xl-5 {
        margin-top: 50px;
    }
    .col-xl-6 {
        margin-top: 0px;
    }
    h1 {
        margin-top: 30px;
        font-size: 36px !important;
    }
    .btn-primary {
        padding: 6px 15px;
    }
    .margenTop {
        top: 150px !important;
    }
    .margenTop h1 {
        font-size: 40px;
    }
    .idea {
        margin: 40px 0 60px 0;
        font-size: 22px;
        line-height: 30px;
    }
}
</style>
